import { render, staticRenderFns } from "./ActividadList.vue?vue&type=template&id=d7b2efa4&"
import script from "./ActividadList.vue?vue&type=script&lang=js&"
export * from "./ActividadList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QToolbar,QToolbarTitle,QBtn,QPagination,QTimeline,QTimelineEntry} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QToolbar,QToolbarTitle,QBtn,QPagination,QTimeline,QTimelineEntry})
